import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const okrDetailsModalStyles = css`
  width: 100%;
  height: 100%;
  max-width: unset;
  margin: 2.4rem;
  max-height: calc(100% - 4.8rem);
  overflow: hidden;
`;

export const OKR_DETAILS_CLASSES = {
  paper: cn('rounded-16 shadow-04', okrDetailsModalStyles),
};
